import React, {Component} from "react";
import { NavLink } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import CustomDropdown from "../components/CustomDropdown";
import Alert from 'react-bootstrap/Alert'

import 'bootstrap/dist/css/bootstrap.min.css';
import "./UploadPostmanCollectionPage.css";
import Sidebar from "../components/Sidebar";
import logo from  "../components/Myntra_logo.png";

import qs from "qs";

import {amcClientId, amcBaseUrl} from  "../common.config"

var clientId = amcClientId || "myntra-swagger-49472439-e658-41f2-93c7-1d2cc36befa5"
var currentUrl = window.location.toString();
var fullUrl = amcBaseUrl + '/login?cidx=' + encodeURIComponent(clientId) + '&pageRequested=' + encodeURIComponent(currentUrl);


class UploadPostmanCollectionPage extends Component {
    state = {
        swaggerRegisteredClients: [],
        selectedFile: "",
        isFilePicked: false,
        selectedClientId: 0,
        selectedClientName: "",
        isAlertBoxVisible: false,
        fileUploadAlertVariant: "success",
        fileUploadAlertMessage: "",
        selectedClientLatestVersion: ""
    };

    componentDidMount() {

        if(this.checkURLParams()){
            var at = qs.parse(window.location.search).access_token;
            var rt = qs.parse(window.location.search).refresh_token;
            //validate at, rt
            this.setCookie("erp.at", at, 1);
            this.setCookie("erp.rt", rt, 1);
            this.setCookie("amc.enabled", true);
        }
        let isTokenValid = this.checkAuthenticated() ? this.validateToken() : false;
        // console.log(isTokenValid);
        if(!isTokenValid) {
          this.deleteCookie("erp.at");
          this.deleteCookie("erp.rt");
            window.location.assign(fullUrl);
        }

        else{
            this.getSwaggerRegisteredClient()
            .then(res => {
                this.setState({swaggerRegisteredClients: res})
            })
            .catch(err => {});
        }
    }

    getSwaggerRegisteredClient = async () => {
        const response = await fetch('/getSwaggerRegisteredClient');
        const body = await response.json();
        if (response.status !== 200) throw Error(body.message);
        return body;
    }

    handleUpload = (event) => {
        this.setState({selectedFile: event.target.files[0]});
        this.setState({ isFilePicked: true });
    }

    getData = async () => {
        let url = /getVersions/ + this.state.selectedClientId;
        const response = await fetch(url);
        const body = await response.json();
        if (response.status !== 200) throw Error(body.message);
        this.updateVersionNumber(body);
    };
     
    updateVersionNumber = (body) => {
        let cnt = 1;
        if (body != null&& body.length > 0) {
            cnt = body[0].update_version + 1;
        }
        this.setState({selectedClientLatestVersion: cnt});
        this.uploadData();
    };

    uploadData = () => {
        const formData = new FormData();

        formData.append("userSelectedFile", this.state.selectedFile);
        formData.append("clientId",this.state.selectedClientId);
        formData.append("clientName",this.state.selectedClientName);
        formData.append("version",this.state.selectedClientLatestVersion);

        let uploadUrl = "/uploadFileToContainer/";
    
        fetch(uploadUrl, {method: 'POST', body: formData})
            .then((response) => {
                if (response.status == 200) {
                    this.setState({isAlertBoxVisible: true, fileUploadAlertVariant: "success", 
                        fileUploadAlertMessage:"File Uploaded Successfully!"}); 
                } else {
                    this.setState({isAlertBoxVisible: true, fileUploadAlertVariant: "danger",
                        fileUploadAlertMessage:"Failed To Upload File!"});
                }
            })
            .catch((error) => {
                console.error('Error', error);
                this.setState({isAlertBoxVisible: true, fileUploadAlertVariant: "danger",
                    fileUploadAlertMessage:"Failed To Upload File!"});
            });
    };
   

    handleSubmission = () => {
        this.getData();
    };

    updateSelectedClientId = (clientId, clientName) => {
        this.setState({selectedClientId: clientId, selectedClientName: clientName});
    }

    validateToken = async () => {
        const response = await fetch('/validateToken');
        if(response.status !== 200) return false;
        // console.log(response.status);
        const body = await response.json();
        // if(!body["isTokenValid"]) window.location.assign(fullUrl);
        return body["isTokenValid"];
    }

    getCookie = (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
  
    setCookie =(name,value,days) => {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
  
    deleteCookie = (name) => {
        this.setCookie(name, '', -1)
    }

    checkAuthenticated = () => {
        var at = this.getCookie("erp.at");
        var rt = this.getCookie("erp.rt");
        return (at !== null && rt !== null);
    }
  
    checkURLParams = () => {
        var at = qs.parse(window.location.search).access_token;
        var rt = qs.parse(window.location.search).refresh_token;
        return at !== undefined && rt !==undefined
    }

    render() {
        let showFileUploadAlert = (
            <Alert variant={this.state.fileUploadAlertVariant} show={this.state.isAlertBoxVisible}>
                {this.state.fileUploadAlertMessage}
            </Alert>
        );

        return (
            <div className="UploadPostmanCollectionPage">
                <div className="UploadPostmanCollectionPageHeader">
                <img src={logo} alt="Myntra Logo"/>
                 <div id="header-text">
                    <div>
                    <h1>Developer API</h1>
                    </div>
                </div>
                    <div id="title">
                    <h1>Upload Postman V2 Collection</h1>
                </div>

                    <div className="wrap">
                    <NavLink className="UploadBtn" to="/internal" exact>
                        <Button variant="outline-light">Back To Home</Button>
                    </NavLink>
                    </div>
                </div>
               <div className="UploadPostmanCollectionPageBody">
                    <div className="MainContent">
                        <div className="UploadContainer">
                            <CustomDropdown 
                                swaggerRegisteredClients={this.state.swaggerRegisteredClients}
                                updateSelectedClientId={this.updateSelectedClientId} />
                            <br/>
                            <div className="FileDetailsContainer">
                                <input type="file" onChange={this.handleUpload} id="file"/>
                                <label for="file" class ="btn-2">Choose a File</label>
                                <p>
                                Filename: {this.state.selectedFile.name}<br />
                                File type: {this.state.selectedFile.type}<br />
                                File size: {this.state.selectedFile.size} bytes</p>
                            </div>
                           {showFileUploadAlert}
                            <br />
                            <div>
                            <Button variant="flat" onClick={this.handleSubmission}>Submit</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UploadPostmanCollectionPage;